export enum Environments {
  DEV = 'develop',
  PERF = 'perf',
  PROD = 'production',
  PROD_AUTH = 'prod_auth',
}
